import { HomeHero } from "@/components/home/HomeHero";
import { JournalsBento } from "@/components/home/JournalsBento";
import { Workflow, Resources, InfoTriptych } from "@/components/home/HomeSections";
import { Marquee, useSeo } from "@/components/site/Motion";
import { site } from "@/content/site";

export default function Home() {
  useSeo(null, site.intro);
  return (
    <div data-testid="home-page">
      <HomeHero />
      <Marquee items={["Science & Technology", "Agriculture & Sustainability", "Social Sciences & Humanities", "Earth Systems & Geoscience", "Open Journal Systems"]} />
      <JournalsBento />
      <Workflow />
      <Resources />
      <InfoTriptych />
    </div>
  );
}
